import script from "./Campus.vue?vue&type=script&setup=true&lang=js"
export * from "./Campus.vue?vue&type=script&setup=true&lang=js"

import "./Campus.vue?vue&type=style&index=0&id=25ad891f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ad891f"]])

export default __exports__